module.exports = __webpack_public_path__ + "img/flag-1.bcd377ec.svg";